import { httpRequest, extensionSafeRedirect, parseQuery } from '@calendly/http-tools'

import validateForm from 'services/validate_form'

export const cancellation = (uuid, formData, validationData) => async (dispatch, getState) => {
  dispatch({ type: 'CANCELLATION_REQUEST' })

  const validation = validateForm(validationData, {
    state: getState(),
    isCancellation: true
  })

  if (!validation.valid) {
    dispatch({
      type: 'SCHEDULING_VALIDATION_FAIL',
      payload: {
        errors: validation.errors
      }
    })
    dispatch({ type: 'CANCELLATION_ERROR' })

    return false
  }

  const [success, responseData] = await httpRequest({
    url: `/api/booking/cancellations/${uuid}`,
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json'
    },
    data: {
      cancellation: formData
    }
  })

  if (success) {
    dispatch({
      type: 'CANCELLATION_DONE',
      payload: responseData
    })
  } else {
    window.location.reload()
    return false
  }


  if (success) {
    const { return_to: returnToUrl, closeRedirectUrl } = parseQuery(window.location.search)
    extensionSafeRedirect(returnToUrl || closeRedirectUrl, true, { id: uuid, success: true, resource: 'invitee' })
  }

  return success
}
